import React, { useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import BackgroundSlider from "../BackGround/BackgroundSlider";
import "react-toastify/dist/ReactToastify.css";
import Logo from "../../images/Logo.png";
import "./Design.css";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function EnterEmail() {
  const [email, setEmail] = useState("");
  const [emailSent, setEmailSent] = useState(false);
  const [loading, setLoading] = useState(false); // Track loading state

  const handleLink = async (event) => {
    event.preventDefault();

    if (email.length === 0) {
      toast.error("Please enter your email");
      return;
    }

    setLoading(true); // Start loading
    try {
      const response = await axios.post(`${BACKEND_URL}/api/request-reset-password`, {
        email,
      });

      if (response.status === 200) {
        toast.success(response.data.message);
        setEmailSent(true);
      }
    } catch (error) {
      console.error("Error requesting password reset:", error);
      if (error.response && error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Failed to send password reset email");
      }
    } finally {
      setLoading(false); // End loading
    }
  };

  return (
    <>
      <div className="header">
        <img src={Logo} alt="Fisko" className="Logo" />
      </div>

      <div className="EnterEmail-page">
        <BackgroundSlider />
        <div className="login-box">
          <main className="loginContainer">
            {emailSent ? (
              <div className="successMessage">
                <h1 className="title">Email Sent Successfully</h1>
                <p className="subtitle">
                  A password reset link has been sent to <strong>{email}</strong>.
                  Please check your inbox.
                </p>
              </div>
            ) : (
              <>
                <header className="headerSection">
                  <h1 className="title">Forgot Password</h1>
                  <h2 className="subtitle">Enter Your Email</h2>
                </header>

                <form onSubmit={handleLink}>
                  <div className="formGroup">
                    <label htmlFor="email" className="inputLabel">
                      Email
                    </label>
                    <input
                      type="email"
                      id="email"
                      className="formInput"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>

                  <button
                    type="submit"
                    className="signUpButton"
                    disabled={loading} // Disable button when loading
                  >
                    {loading ? "Sending..." : "Send Link"}
                  </button>
                </form>
              </>
            )}
          </main>
        </div>
      </div>

      <ToastContainer />
    </>
  );
}
